import * as moment from 'moment';

import {DATE_FORMAT} from '../../../app.constants';
import {
  DAYS_IN_WEEK,
  DEFAULT_WEEK_START,
  HrCalendarDay,
  HrCalendarMonth,
  HrCalendarWeek,
  WeekStartDay
} from '../hr-calendar.models';

const SATURDAY = 6;
const SUNDAY = 0;

export class HrCalendarGridUtil {

  public static firstOfMonth(date: Date): Date {
    return moment(date).startOf('month').toDate();
  }

  public static addMonths(viewDate: Date, delta: number): Date {
    return moment(viewDate).startOf('month').add(delta, 'months').toDate();
  }

  public static weekdayOrder(weekStart: WeekStartDay = DEFAULT_WEEK_START): number[] {
    return Array.from({length: DAYS_IN_WEEK}, (_, index) => (weekStart + index) % DAYS_IN_WEEK);
  }

  public static buildMonth(viewDate: Date,
                           weekStart: WeekStartDay = DEFAULT_WEEK_START,
                           today: Date = new Date()): HrCalendarMonth {
    const monthStart = moment(viewDate).startOf('month');
    const monthEnd = moment(viewDate).endOf('month').startOf('day');
    const gridStart = monthStart.clone().subtract((monthStart.day() - weekStart + DAYS_IN_WEEK) % DAYS_IN_WEEK, 'days');
    const gridEnd = monthEnd.clone().add((weekStart + DAYS_IN_WEEK - 1 - monthEnd.day()) % DAYS_IN_WEEK, 'days');
    const todayIso = moment(today).format(DATE_FORMAT);

    const weeks: HrCalendarWeek[] = [];
    const cursor = gridStart.clone();
    while (!cursor.isAfter(gridEnd, 'day')) {
      const days: HrCalendarDay[] = [];
      for (let i = 0; i < DAYS_IN_WEEK; i++) {
        days.push(this.toDay(cursor, monthStart, todayIso));
        cursor.add(1, 'day');
      }
      weeks.push({days});
    }

    return {
      viewDate: monthStart.toDate(),
      weekdays: this.weekdayOrder(weekStart),
      weeks
    };
  }

  private static toDay(cursor: moment.Moment, monthStart: moment.Moment, todayIso: string): HrCalendarDay {
    const isoDate = cursor.format(DATE_FORMAT);
    const dayOfWeek = cursor.day();
    return {
      date: cursor.toDate(),
      isoDate,
      dayOfMonth: cursor.date(),
      dayOfWeek,
      inMonth: cursor.isSame(monthStart, 'month'),
      isWeekend: dayOfWeek === SATURDAY || dayOfWeek === SUNDAY,
      isToday: isoDate === todayIso
    };
  }
}

